import { IconDots } from '@tabler/icons-react';
import {
    AppButton,
    AppButtonProps,
} from 'components/atoms/CommonAppComponents/AppButton/AppButton';

type AppMoreButtonProps = Omit<AppButtonProps, 'ghost' | 'icon'> & {
    accessibilityLabel?: string;
};

export const AppMoreButton = ({
    accessibilityLabel = 'Więcej opcji',
    ...props
}: AppMoreButtonProps) => (
    <AppButton
        ghost
        icon={<IconDots size={20} />}
        accessibilityLabel={accessibilityLabel}
        {...props}
    />
);
